var map = {
	"./BlockEdit.vue": "./js/BlockEdit.vue",
	"./MobileBanner.vue": "./js/MobileBanner.vue",
	"./PrivacyPopup.vue": "./js/PrivacyPopup.vue",
	"./RegisterForm2.vue": "./js/RegisterForm2.vue",
	"./RegisterForm2Business.vue": "./js/RegisterForm2Business.vue",
	"./RegisterForm2BusinessContact.vue": "./js/RegisterForm2BusinessContact.vue",
	"./RegisterForm2Personal.vue": "./js/RegisterForm2Personal.vue",
	"./RegisterForm3.vue": "./js/RegisterForm3.vue",
	"./RegisterFormPartner.vue": "./js/RegisterFormPartner.vue",
	"./RegisterFormPartnerContact.vue": "./js/RegisterFormPartnerContact.vue",
	"./RegisterPartner.vue": "./js/RegisterPartner.vue",
	"./SessionTimeout.vue": "./js/SessionTimeout.vue",
	"./SysStatusPub.vue": "./js/SysStatusPub.vue",
	"./TermsPopup.vue": "./js/TermsPopup.vue",
	"./app-errors.vue": "./js/app-errors.vue",
	"./validator.vue": "./js/validator.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js sync .+\\.vue$";